import cx from 'classnames';
import store from '~/javascripts/store.js';
import { Component } from 'react';
import { observer } from 'mobx-react';

const DonateFormDonationFrequencyToggle = observer(
  class DonateFormDonationFrequencyToggle extends Component {
    toggle = (isSubscription) => {
      store.donateForm.isSubscription = isSubscription;

      store.donateForm.step = 'amount';
      store.donateForm.creditCardStep = 1;
      store.donateForm.phoneNumber.hiddenFieldValue = '';
      store.donateForm.setCustomDefaultAmount();
      store.donateForm.setOptimizelyAmount();
      store.donateForm.isWpsAmountButtonSelected = false;
      store.donateForm.setSelectedPaymentTab();

      if (store.donateForm.subscriptionUpsell.isOptedIn) {
        store.donateForm.subscriptionUpsell.toggleIsOptedIn(
          store.donateForm.isAnnual ? 'annual' : 'monthly',
          false
        );
        store.donateForm.isSubscription = isSubscription;
      }

      store.donateForm.subscriptionUpsell.originalPeriod =
        store.donateForm.frequency;
    };

    render() {
      if (!store.donateForm.showDonationFrequencyToggle) return null;

      const { isSubscription } = store.donateForm;

      return (
        <div>
          <div className='mb-2 monthly-subscription toggle-buttons w-full'>
            <a
              className={cx('toggle-one-time', {
                active: !isSubscription,
                'pointer-events-none': store.donateForm.disableFormSubmit,
              })}
              onClick={() => this.toggle(false)}
            >
              Give Once
            </a>
            <a
              className={cx('toggle-monthly', {
                active: isSubscription,
                'pointer-events-none': store.donateForm.disableFormSubmit,
              })}
              onClick={() => this.toggle(true)}
            >
              Monthly
            </a>
          </div>

          {this.props.monthlyToggleCtaText &&
            store.donateForm.step === 'amount' && (
              <div className='-mt-1 mb-2 monthly-toggle-cta-wrapper'>
                <span
                  dangerouslySetInnerHTML={{
                    __html: this.props.monthlyToggleCtaText,
                  }}
                />
              </div>
            )}
        </div>
      );
    }
  }
);

export default DonateFormDonationFrequencyToggle;
